import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./slider.module.css";
import next from "../../images/next.svg";
import prev from "../../images/prev.svg";
import { Link } from "react-router-dom";

function SampleNextArrow(props) {
  const { className, onClick } = props;
  return (
    <div onClick={onClick}>
      <img src={next} alt="" className={className} />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, onClick } = props;
  return (
    <div onClick={onClick}>
      <img src={prev} alt="" className={className} />
    </div>
  );
}

function playlistSlider({ heading, playlist, info = undefined }) {
  let width = window.innerWidth;

  const settings = {
    dots: false,
    infinite: true,
    speed: 400,
    slidesToShow: width < 768 ? 1 : 4,
    slidesToScroll: 1,
    autoplay: true,
    adaptiveHeight: true,
    autoplaySpeed: 1500,
    pauseOnHover: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    centerMode: true,
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>{heading && heading}</h2>
      <Slider {...settings} className={styles.slider}>
        {playlist &&
          playlist.map(
            (item) =>
              item?.videos[0]?.thumbnail && (
                <Link
                  key={item._id}
                  to={`/creator/${item.creator?.name}/${item.language}/${item.name}/${item._id}`}
                >
                  {/* {console.log("item ", item÷ßß÷)} */}
                  <div style={{ margin: "10px 0", height: "240px" }}>
                    <img
                      src={item?.videos[0]?.thumbnail}
                      alt=""
                      className={styles.img}
                    />
                    <p className={styles.title}>
                      {item?.name?.substring(0, 100)}..
                    </p>
                    <div className={styles.box}>
                      <span className={styles.creator}>
                        By {item?.creator?.name}
                      </span>
                      <span className={styles.rating}>
                        {isNaN(Number(item?.avgRating).toFixed(1))
                          ? 0
                          : Number(item?.avgRating).toFixed(1)}
                      </span>
                    </div>
                    {info && (
                      <p className={styles.info}>
                        {item?.description?.substring(0, 100)}....
                      </p>
                    )}
                  </div>
                </Link>
              ),
          )}
      </Slider>
    </div>
  );
}

export default playlistSlider;
